"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _styles = require("./styles");

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

var Button = function Button(_ref) {
  var id = _ref.id,
      buttonType = _ref.buttonType,
      label = _ref.label,
      image = _ref.image,
      altText = _ref.altText,
      buttonFont = _ref.buttonFont,
      _onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: id,
    className: buttonType,
    buttonFont: buttonFont,
    onClick: function onClick(e) {
      e.stopPropagation();

      _onClick(e);
    },
    disabled: buttonType === "general-button-disabled",
    children: [buttonType.includes("general") && label, image && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: image,
      alt: altText
    })]
  }, "button-".concat(buttonType));
};

exports.Button = Button;
Button.defaultProps = {
  buttonType: "purple-button",
  buttonFont: "Avenir Next"
};